import { capitalize } from 'helpers/utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AwardsIcons, { SizingOptions } from '../AwardsIcons/AwardsIcons';
import { staticContent } from 'components/constants/Constants';

//TODO: improve this type in order to not repeated keys ont he unions
type AwardDisplayProps =
  | {
      variant: AwardsDisplayVariants.ICON;
      size?: SizingOptions;
      awardValue?: string;
      award: any;
    }
  | {
      variant: AwardsDisplayVariants.IMAGE;
      award: AwardDisplayProps;
      size?: SizingOptions;
    };

export enum AwardsDisplayVariants {
  IMAGE = 'Image',
  ICON = 'Icon'
}
export const AwardDisplay = (props: AwardDisplayProps) => {
  const { award } = props;

  const srcValue = `${award.event.key}--${award.category.key}--${award.year}--${
    award?.winner ? award?.prize_level : 'Nominee'
  }.jpg`;
  const toolTip = `${award.event.name}${' | ' + award.year} ${
    ' | ' + award.category.name
  }  ${award?.winner ? ' | ' + award?.prize_level : 'Nominee'} Award`;
  const iconValue = getCorrectAwardIconName(award);

  return (
    <>
      {props.variant === AwardsDisplayVariants.ICON && (
        <AwardsIcons
          awardValue={iconValue}
          toolTip={toolTip}
          size={props.size}
        />
      )}
      {props.variant === AwardsDisplayVariants.IMAGE && (
        <OverlayTrigger placement="top" overlay={<Tooltip>{toolTip}</Tooltip>}>
          <img
            className={`award-display-image award-display-image-${props.size}`}
            src={staticContent + '/rx/awards/images/' + srcValue.toLowerCase()}
            alt={toolTip}
          />
        </OverlayTrigger>
      )}
    </>
  );
};

const getCorrectAwardIconName = (award: any) => {
  let iconName = '';
  const key = award?.category.key;

  if (key === 'innovation-zone') {
    return 'innovation-zone.svg';
  }
  if (key === 'sustainability-zone') {
    return 'sustainability-zone.svg';
  }
  if (key) {
    switch (key) {
      case 'rising-star':
        iconName = 'risingStar';
        break;
      case 'green-ingredient':
        iconName = 'Green';
        break;
      case 'kenvue-trusted-science-award':
        iconName = 'Kenvue';
        break;
      default:
        iconName = 'FI';
        break;
    }
  }

  iconName +=
    '-' +
    capitalize(
      award?.winner
        ? award?.prize_level === 'WINNER'
          ? 'Gold'
          : award?.prize_level === 'RUNNER_UP'
          ? 'Silver'
          : award.prize_level !== 'NONE'
          ? award.prize_level
          : 'Nominee'
        : 'Nominee'
    );

  return iconName + '.svg';
};
